import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import './futures-external-search.m.css';
import SearchFuturesOptions from './search-stocks';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import './futures-external-search.m.css';

const FuturesExternalSearch = () => {
  const [futuresOptionData, setFuturesOptionsData] = useState({});
  const [selectedStock, setSelectedStock] = useState('NIFTY 50');
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getFuturesOptionOverallDataForQueryForFutures = async (stockName) => {
    const response = await fetch(`/foapi/future/getSummary?exchangeSymbol=${stockName}`);
    return response.json();
  };

  const resultFuturesOptionsSummaryForFutures = useQuery(
    'getFuturesOptionsSummaryForFuturesExternal',
    () => getFuturesOptionOverallDataForQueryForFutures(selectedStock),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setFuturesOptionsData(data?.data);
      },
      enabled:
        initialLoading ||
        (!!selectedStock && isWithinTradingHours(tradingHolidays, specialTradingDays)),
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (resultFuturesOptionsSummaryForFutures?.isSuccess) {
      setFuturesOptionsData(resultFuturesOptionsSummaryForFutures?.data?.data);
    }
  }, []);

  const getFuturesOptionOverallData = async (stockName) => {
    const data = await getFuturesOptionOverallDataForQueryForFutures(stockName);
    setFuturesOptionsData(data?.data);
  };

  const stockSearchHandler = (stockName) => {
    setSelectedStock(stockName);
    const formatedStockName = stockName.replace(' ', '%20');
    getFuturesOptionOverallData(formatedStockName);
  };

  const stockSearchCloseHandler = (defaultStatus) => {
    if (defaultStatus) {
      stockSearchHandler('NIFTY 50');
    }
  };

  return (
    <React.Fragment>
      {initialLoading ? (
        <div styleName="initial-loading-container"></div>
      ) : (
        <>
          <div styleName="futures-header" className="mobile-only">
            <div styleName="letter-container">
              <span styleName="letter">{selectedStock.toString().charAt(0)}</span>
            </div>
            <div styleName="overall-stats-container">
              <SearchFuturesOptions
                onStockSearch={stockSearchHandler}
                onCloseSearch={stockSearchCloseHandler}
              />

              <div styleName="statistics-container">
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData?.['spot-price']
                      ? futuresOptionData?.['spot-price']
                      : '-'}{' '}
                    <br /> <span styleName="stat-desc">Spot Price</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData?.basis ? futuresOptionData?.basis : '-'}{' '}
                    <br /> <span styleName="stat-desc">Basis</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['1m-future']
                      ? futuresOptionData['1m-future']
                      : '-'}
                    <br /> <span styleName="stat-desc">1M Futures</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['2m-future']
                      ? futuresOptionData['2m-future']
                      : '-'}
                    <br /> <span styleName="stat-desc">2M Futures</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['roll-spread']
                      ? futuresOptionData['roll-spread']
                      : '-'}
                    <br /> <span styleName="stat-desc">Rollover Spread</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['roll-over-percentage']
                      ? `${futuresOptionData['roll-over-percentage']}%`
                      : '-'}
                    <br /> <span styleName="stat-desc">Rollover%</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['open-interest']
                      ? `${futuresOptionData['open-interest']}`
                      : '-'}
                    <br /> <span styleName="stat-desc">Open Interest</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['openinterest-change-percentage']
                      ? `${futuresOptionData['openinterest-change-percentage']}%`
                      : '-'}
                    <br /> <span styleName="stat-desc">OI% Change</span>
                  </p>
                </div>
                <div styleName="stats">
                  <p styleName="stat-value">
                    {futuresOptionData && futuresOptionData['put-call-ratio']
                      ? futuresOptionData['put-call-ratio']
                      : '-'}
                    <br /> <span styleName="stat-desc">Put Call Ratio</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div styleName="futures-header-alt" className="desktop-only">
            <div styleName="letter-container-alt">
              <span styleName="letter-alt">{selectedStock?.toString()?.charAt(0)}</span>
            </div>
            <div>
              <SearchFuturesOptions
                onStockSearch={stockSearchHandler}
                onCloseSearch={stockSearchCloseHandler}
              />
            </div>

            <div styleName="statistics-container">
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData?.['spot-price']
                    ? futuresOptionData?.['spot-price']
                    : '-'}{' '}
                  <br /> <span styleName="stat-desc">Spot Price</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData?.basis ? futuresOptionData?.basis : '-'}{' '}
                  <br /> <span styleName="stat-desc">Basis</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['1m-future']
                    ? futuresOptionData['1m-future']
                    : '-'}
                  <br /> <span styleName="stat-desc">1M Futures</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['2m-future']
                    ? futuresOptionData['2m-future']
                    : '-'}
                  <br /> <span styleName="stat-desc">2M Futures</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['roll-spread']
                    ? futuresOptionData['roll-spread']
                    : '-'}
                  <br /> <span styleName="stat-desc">Rollover Spread</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['roll-over-percentage']
                    ? `${futuresOptionData['roll-over-percentage']}%`
                    : '-'}
                  <br /> <span styleName="stat-desc">Rollover%</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['open-interest']
                    ? `${futuresOptionData['open-interest']}`
                    : '-'}
                  <br /> <span styleName="stat-desc">Open Interest</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['open-interest-change-percentage']
                    ? `${futuresOptionData['open-interest-change-percentage']}%`
                    : '-'}
                  <br /> <span styleName="stat-desc">OI% Change</span>
                </p>
              </div>
              <div styleName="stats">
                <p styleName="stat-value">
                  {futuresOptionData && futuresOptionData['put-call-ratio']
                    ? futuresOptionData['put-call-ratio']
                    : '-'}
                  <br /> <span styleName="stat-desc">Put Call Ratio</span>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default FuturesExternalSearch;
